<template>
  <div v-if="visit">
    <div class="visit-meta">
      <h3>Venue visit</h3>
      <vs-chip :color="isComplete ? 'success' : 'primary'" class="ml-4">{{
        isComplete ? "Completed" : `In progress (${visit.percentageComplete}%)`
      }}</vs-chip>
    </div>
    <vs-breadcrumb class="mt-2">
      <li>
        <router-link to="/vp/lists">Lists</router-link>
        <span class="vs-breadcrum--separator">/</span>
      </li>
      <li>
        Venue visits
        <span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="active">
        {{ visit.title }}
      </li>
    </vs-breadcrumb>
    <vs-tabs
      :position="isSmallerScreen ? 'top' : 'left'"
      class="tabs-shadow-none mt-8"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <!-- ANSWERS AND ANSWERS -->
      <vs-tab
        icon-pack="feather"
        icon="icon-info"
        :label="!isSmallerScreen ? 'Answers' : ''"
      >
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <visit-answers
            :type="type"
            :visit="visit"
            v-if="questions"
            :answers="answers"
            :questions="questions"
          />
        </div>
      </vs-tab>

      <!-- INFO -->
      <vs-tab
        icon-pack="feather"
        icon="icon-info"
        :label="!isSmallerScreen ? 'Info' : ''"
      >
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <visit-info :visit="visit" />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import VisitAnswers from "./VisitAnswers.vue";
import VisitInfo from "./VisitInfo.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    VisitAnswers,
    VisitInfo,
  },
  data() {
    return {
      surveySessionId: "",
      type: "",
    };
  },
  methods: {
    /*getItem: function () {
      

      
    },*/
  },
  computed: {
    ...mapGetters({
      vs: "venues/visit",
    }),
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    visit() {
      return this.vs(this.surveySessionId);
    },
    questions() {
      return this.visit.modules[0].lessons[0].questions;
    },
    answers() {
      return this.visit.answers;
    },
    isComplete() {
      return this.visit.percentageComplete === 100;
    },
  },
  async created() {
    this.surveySessionId = this.$route.params.surveySessionId;
    this.type = this.$route.params.type;
    this.$vs.loading();
    await this.$store.dispatch("venues/getVisitDetails", this.surveySessionId);
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}

.visit-meta {
  display: flex;
}
</style>